import React from 'react';
import strings from 'utils/strings';
class NewCandidateModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isCreatingNewClass: true,
			userClasses: [],
		};
	}
	componentDidMount() {}
	render() {
		return (
			<div
				className="lit-modal"
				onClick={() => {
					this.props.closeWindow();
				}}
			>
				<div
					className="lit-modal__island"
					onClick={(event) => {
						event.stopPropagation();
					}}
				>
					<h3>{strings.candidates.newCandidateModalTitle}</h3>
					<form
						className="register-form"
						onSubmit={() => {
							/* event.preventDefault();
							const testAdminResult = updateObject(testAdmin);
                            onSave(testAdminResult); */
						}}
					>
						<br />
						{/* <h3>{strings.auth.personalinformation}</h3> */}
						<div className="lit-input inline">
							<label
								className="lit-input__label wide"
								htmlFor="test-admin-modal-firstName"
							>
								{strings.common.firstname}
							</label>
							<input
								className="lit-input__field"
								id="test-admin-modal-firstName"
								name="firstName"
								/* onChange={this.handleUpdateTestAdminEvent} */
								placeholder={strings.common.placeholderFirstName}
								required
								type="text"
								/* value={testAdmin.firstName || ''} */
							/>
						</div>
						<div className="lit-input inline">
							<label
								className="lit-input__label wide"
								htmlFor="test-admin-modal-lastName"
							>
								{strings.common.lastname}
							</label>
							<input
								className="lit-input__field"
								id="test-admin-modal-lastName"
								name="lastName"
								/* onChange={this.handleUpdateTestAdminEvent} */
								placeholder={strings.common.placeholderLastName}
								required
								type="text"
								/* value={testAdmin.lastName || ''} */
							/>
						</div>
						<div className="lit-input inline">
							<label
								className="lit-input__label wide"
								htmlFor="test-admin-modal-organization"
							>
								{strings.auth.shcool_or_company}
							</label>
							<input
								className="lit-input__field"
								id="test-admin-modal-organization"
								name="organization"
								/* onChange={this.handleUpdateTestAdminEvent} */
								placeholder={strings.common.placeholderOrganization}
								type="text"
								/* value={testAdmin.organization || ''} */
							/>
						</div>
						<div className="lit-input inline">
							<label
								className="lit-input__label wide"
								htmlFor="test-admin-modal-email"
							>
								{strings.common.email}
							</label>
							<input
								className="lit-input__field"
								id="test-admin-modal-email"
								name="email"
								onChange={this.handleUpdateTestAdminEvent}
								placeholder={strings.common.placeholderEmail}
								required
								type="email"
								/* value={testAdmin.email || ''} */
							/>
						</div>
						<div className="lit-input inline">
							<label
								className="lit-input__label wide"
								htmlFor="test-admin-modal-phone"
							>
								{strings.common.telephone}
							</label>
							<input
								className="lit-input__field"
								id="test-admin-modal-phone"
								name="phone"
								/* onChange={this.handleUpdateTestAdminEvent} */
								placeholder={strings.common.placeholderPhoneNumber}
								required
								type="tel"
								/* value={testAdmin.phone || ''} */
							/>
						</div>

						<div className="lit-input">
							<button className="lit-btn bg-primary">
								{
									/* `${
									isCreate
										? strings.users.addtestadministrator
										: strings.candidates.saveuserinformation
								}` */
								   strings.candidates.newCandidate
								}
							</button>
							<button
								className="lit-btn bg-negative2"
								onClick={() => this.props.closeWindow()}
							>
								{strings.common.cancel}
							</button>
						</div>
					</form>
				</div>
			</div>
		);
	}
}
export default NewCandidateModal;
